import React  from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import s from './ProductLabels.scss'

import newImage from './images/new.svg'
import bestsellerImage from './images/bestseller.svg'
import limitedEditionImage from './images/limited-edition.svg'
import soldOutImage from './images/out-of-stock.svg'


const ProductLabels = ({ items: labels, className }) => {
  const isNew             = labels.some((item) => /new/.test(item))
  const isBestseller      = labels.some((item) => /bestseller/.test(item))
  const isLimitedEdition  = labels.some((item) => /limited-edition/.test(item))
  const isSoldOut         = labels.some((item) => /sold-out/.test(item))
  const items             = []

  if (isSoldOut) {
    items.push({ src: soldOutImage, name: 'SoldOut' })
  }

  if (isLimitedEdition) {
    items.push({ src: limitedEditionImage, name: 'Lep', className: s.limitedEdition })
  }
  else if (isNew || isBestseller) {
    if (isNew) {
      items.push({ src: newImage, name: 'New' })
    }

    if (isBestseller) {
      items.push({ src: bestsellerImage, name: 'Bestseller' })
    }
  }

  return Boolean(items.length) && (
    <div className={className}>
      {
        items.map(({ src, name, className }) => (
          <img
            key={name}
            className={(cx(className, s.image))}
            src={src}
            alt=""
            data-testid={`product${name}Label`}
          />
        ))
      }
    </div>
  )
}

ProductLabels.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string),
}

ProductLabels.defaultProps = {
  items: [],
}


export default ProductLabels
